const skillsData = [
  "Fashion Management",
  "Styling",
  "Brand Communication",
  "Trend Analysis",
  "Visual Merchandising",
  "Customer Experience"
];

export default skillsData;